import GtrSuper from '@/modules/common/components/mixins/gtr-super.mixin'
import GtrEventBookmarks from '@/modules/common/components/ui-core/gtr-event-bookmarks/gtr-event-bookmarks.vue'
import { Component, Prop } from 'vue-property-decorator'
import { mapState } from 'vuex'

@Component({
  name: 'GtrFamiliarUiHeader',
  computed: {
    ...mapState('common', ['noticeDisplayed'])
  },
  components: {
    'gtr-event-bookmarks': GtrEventBookmarks
  }
})
export default class GtrFamiliarUiHeader extends GtrSuper {
  @Prop({ type: String, default: 'admin' }) readonly context!: 'admin' | 'company' | 'event'
  @Prop({ type: Boolean, default: false }) readonly mobileNav!: boolean

  noticeDisplayed!: boolean
  supportHovered = false
  profileIconHovered = false

  get isMobile (): boolean {
    return this.$vuetify.breakpoint.xsOnly
  }

  onToggleNavDrawer (): void {
    this.$emit(this.mobileNav && this.isMobile ? 'toggle-mobile-nav' : 'toggle-nav-drawer')
  }
}
